import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

const GlobalStyle = createGlobalStyle`
*,*::before,*::after {
  box-sizing:border-box;
  -webkit-font-smoothing:antialiased;
  -moz-osx-font-smoothing:grayscale;
}
body {
  padding:0;
  margin:0;
  font-family: 'Open Sans', sans-serif;
}
h1, h2, h3, h4, h5, h6 {
    margin: 0;
}
`;

export default GlobalStyle;
